import { Component } from '@angular/core';
import { ModalController, NavController } from 'ionic-angular';
import { TecladoComponent } from '../teclado/teclado';
import { UtilsProvider } from '../../providers/utils/utils';
import { Storage } from '@ionic/storage'
import { MeseromeseroPage } from '../../pages/meseromesero/meseromesero';
import { UsuariosProvider } from '../../providers/usuarios/usuarios';

@Component({
  selector: 'usuariopedidosalon',
  templateUrl: 'usuariopedidosalon.html',
  providers: []
})
export class UsuarioPedidoSalonComponent  {

  usuarios = [];
  recorrerVal = []
  constructor(public modalCtrl: ModalController, public utils:UtilsProvider,public storages:Storage,
    public navCtrl: NavController,public servicio: UsuariosProvider
  ) {
    this.cargarColores();
  }

  // Obtener iniciales del usuario
  getIniciales(nombre: string): string {
    const palabras = nombre.split(' ');
    return palabras.map(p => p[0]).join('').toUpperCase();
  }

  // Obtener color de usuario desde localStorage o generarlo si no existe
  getColorUsuario(nombre: string): string {
    let coloresGuardados = JSON.parse(localStorage.getItem('coloresUsuarios')) || {};

    if (!coloresGuardados[nombre]) {
      coloresGuardados[nombre] = this.generarColor(nombre);
      localStorage.setItem('coloresUsuarios', JSON.stringify(coloresGuardados));
    }

    return coloresGuardados[nombre];
  }

  // Generar color único basado en el nombre
  generarColor(nombre: string): string {
    let hash = 0;
    for (let i = 0; i < nombre.length; i++) {
      hash = nombre.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `#${('00000' + (hash & 0xffffff).toString(16)).slice(-6)}`;

    return color;
  }

  // Asignar colores a cada usuario al cargar la página
  cargarColores() {
    this.usuarios.forEach(usuario => {
      usuario['colorAvatar'] = this.getColorUsuario(usuario.nombreUsuario);
    });
  }

  // Guardar usuario seleccionado en localStorage
  seleccionarUsuario(usuario) {
    localStorage.setItem('usuarioSeleccionado', JSON.stringify(usuario));
    console.log('Usuario seleccionado:', usuario);
    // Aquí puedes navegar a otra página
  }

  volver() {
    console.log('Volver al menú');
    // Aquí puedes redirigir al usuario a la página anterior
  }
  abrirConfiguracion() {
    console.log("Abrir configuración de clave");
  }
  abrirTeclado(usuario) {
    const modal = this.modalCtrl.create(TecladoComponent, {
      usuario: usuario
    });

    modal.onDidDismiss(async (claveIngresada, usuariosId) => {
      if (claveIngresada) {
        let data =  await this.servicio.buscarClavePedidosSalonPorUsuarioId(usuariosId)
        let response:any = JSON.parse(data['_body']).data[0]
       if(response !== null && response[0]) {
        if(claveIngresada == response[0].clavePedidosSalon) {
            this.abrirPagina('MeseromeseroPage','MeseromeseroPage',usuariosId,response[0].nombreUsuario)
        } else {
          this.utils.mensajeMuestro('Clave pedido salón','La clave ingresada no es valida verifique','warning')
        }
       }

      }
    });

    modal.present();
  }

  abrirPagina(pagina:any,nombre:string,usuariosId:any,nombreUsuario:any){
    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        this.utils.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique.', 'warning')
      }else{
        this.accesosDirectos(pagina,usuariosId,nombreUsuario)
      }

    })

  }

    accesosDirectos(ruta:any,usuariosId:any,nombreUsuario:any) {
      switch(ruta){
        case "MeseromeseroPage":
        this.navCtrl.push(MeseromeseroPage,{permiteIngresar:true,usuariosId:usuariosId,nombreUsuario:nombreUsuario})
        break;
      }
    }

  ionViewDidLoad() {
    this.cargarUsuarios()
  }

  async cargarUsuarios() {
    let companiasId = await localStorage.getItem('companiasId')
    let data =  await this.servicio.buscarUsuarios(companiasId)
    let response = JSON.parse(data['_body']).data[0]
   if(response !== null && response[0]) {
     this.usuarios =  response
     this.cargarColores();
    }

  }
  atras(){

    this.navCtrl.setRoot('HomePage');
  }

}





// WEBPACK FOOTER //
// ./src/components/usuariopedidosalon/usuariopedidosalon.ts